'use client';

import { BookmarkMinus } from 'lucide-react';
import { toast } from 'sonner';
import { api } from 'trpc/react';
import { withConfirmation } from '~/entities/Confirmation';
import { useInvalidateAll } from '~/features/Cache';
import { TooltipAction, type TooltipActionProps } from '~/shared/ui/TooltipAction';

type Props = TooltipActionProps & {
    onOpenChange: (open: boolean, clear?: boolean) => void;
    selectionListId: string;
    selectionListName?: string;
    products: ReadonlyArray<{ id: string }>;
};

export const RemoveProductsFromSelectionListAction: React.FC<Props> = ({
    open,
    index,
    onOpenChange,
    selectionListId,
    selectionListName,
    products,
}) => {
    const productIds = products.map(p => p.id);
    const { mutate: invalidateAll } = useInvalidateAll();

    const { mutate } = api.selectionList.removeProductsFromSelectionListMany.useMutation({
        onMutate: () => toast.loading('Удаляем товары из подборки...', { id: 'removeFromList' }),
        onSuccess: res => {
            invalidateAll();
            onOpenChange(false, true);
            toast.success(`Удалено связей: ${res?.totals?.deletedLinks ?? 0}`, { id: 'removeFromList' });
        },
        onError: () => toast.error('Не удалось удалить товары из подборки', { id: 'removeFromList' }),
    });

    const title = selectionListName ? `«${selectionListName}»` : '';

    return (
        <TooltipAction open={open} index={index}>
            <button
                type='button'
                className='block h-full w-full p-2'
                onClick={withConfirmation(
                    () => mutate({ selectionListId, productIds }),
                    `Удалить выбранные товары (штук: ${productIds.length}) из подборки ${title}? Это НЕ удалит сами товары, только связь с подборкой.`,
                )}
                aria-label='Удалить из подборки'
                title='Удалить из подборки'
            >
                <BookmarkMinus className='h-full w-full text-red-500' />
            </button>
        </TooltipAction>
    );
};
